import { Box, styled, useTheme } from '@mui/material';

export const AgGridTableContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const theme = useTheme();

  return (
    <Container>
      <Box
        sx={{
          width: '100%',
          '& .ag-root-wrapper': {
            // border: 'none',
          },
          '& .ag-root': {
            // border: 'none',
          },
          '& .ag-body': {
            height: 'auto !important',
          },
          '& .ag-center-cols-container': {
            minHeight: '0 ',
          },
          '& .ag-center-cols-viewport': {
            height: 'auto !important',
            minHeight: '46px !important',
          },
        }}
      >
        <div data-ag-theme-mode={theme.palette.mode}>{children}</div>
      </Box>
    </Container>
  );
};

export const Container = styled(Box)({
  width: '100%',
  paddingBottom: '66px',
});
